import React from 'react';
import { CardListingSearchFilters, FilterKey, FilterValue } from '../FilterTypes';
import { FilterContainer, Filters, StyledFilterPills } from './FilterMobileMenuV2.style';
import { FilterChip } from '../FilterStyles.styles';
import { getSortLabel } from './utils';

interface FilterMobileMenuV2Props {
  filterMenuList?: any[];
  clearFilters: () => void;
  updateFilter: (filterKey: FilterKey, filterValue?: FilterValue) => void;
  openDrawer: (fitlerKey: string) => void;
  hidePills?: boolean;
  searchFilters: CardListingSearchFilters;
}

export const FilterMobileMenuV2: React.FC<FilterMobileMenuV2Props> = ({
  filterMenuList = [],
  clearFilters,
  updateFilter,
  hidePills,
  openDrawer,
  searchFilters,
}) => {
  return (
    <FilterContainer>
      <Filters data-testid="plp-filters-wrapper">
        <FilterChip key="sort-by" onClick={() => openDrawer('Sort')}>
          Sort: {getSortLabel(searchFilters.sorts)}
        </FilterChip>
        {filterMenuList.map(filterMenu => (
          <FilterChip
            key={filterMenu.label}
            onClick={() => openDrawer(filterMenu.label)}
            selected={filterMenu.isActive}
          >
            {filterMenu.label} {filterMenu.numSelected() ? `(${filterMenu.numSelected()})` : null}
          </FilterChip>
        ))}
      </Filters>
      {!hidePills ? (
        <StyledFilterPills
          clearFilters={clearFilters}
          updateFilter={updateFilter}
          searchFilters={searchFilters}
        />
      ) : null}
    </FilterContainer>
  );
};
